/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './RecordListRendererStyles.scss';
const baseClass = 'qmb-ui-RecordListRenderer';
export function RecordListRenderer({ block }) {
    const list = block;
    const sections = list.items.map((item, index) => {
        var _a;
        const content = (React.createElement("div", { key: item.resource_id, className: `${baseClass}__item` },
            React.createElement("div", { className: `${baseClass}__item-main` },
                React.createElement(Text, { variant: "body" },
                    React.createElement("strong", null, item.title)),
                item.subtitle && (React.createElement(Text, { variant: "body", className: `${baseClass}__subtitle` }, item.subtitle))),
            React.createElement("div", { className: `${baseClass}__item-meta` },
                item.status && (React.createElement("span", { className: `${baseClass}__status` },
                    item.status.label,
                    React.createElement("i", { className: "fa-solid fa-circle", style: { color: item.status.color } }))),
                item.meta && React.createElement(Text, { variant: "body" }, item.meta)),
            item.url ? (React.createElement("a", { href: item.url, target: "_blank", rel: "noopener noreferrer", "aria-label": (_a = item.title) !== null && _a !== void 0 ? _a : 'Open link' },
                React.createElement("i", { className: "fa-light fa-external-link" }))) : null));
        return {
            label: list.title && index === 0 ? list.title : undefined,
            content
        };
    });
    if (list.truncated) {
        sections.push({
            label: undefined,
            content: (React.createElement(Text, { variant: "body", className: `${baseClass}__truncated` },
                "Showing ",
                list.items.length,
                " of ",
                list.total_count,
                " results"))
        });
    }
    return React.createElement(AIGeneralBlockCard, { sections: sections });
}
